/** Display helpers aligned with User model (User-Model.js). */

export function filterSubscriptionCustomers(users) {
  return (users || []).filter((u) => u.purchaseType === 'subscriptionuser');
}

export function primarySubscriptionPlan(user) {
  const plans = user?.usersubscriptionplans;
  if (!Array.isArray(plans) || !plans.length) return null;
  return plans[0];
}

export function planPaymentStatus(user) {
  return primarySubscriptionPlan(user)?.planpaymentStatus || '—';
}

export function planNameLabel(user) {
  const p = primarySubscriptionPlan(user);
  return p?.planName || '—';
}

export function billingProfileSummary(user) {
  const bp = user?.billingProfile;
  if (!bp) return '—';
  const parts = [bp.legalName, bp.gstin, bp.stateCode].filter(Boolean);
  return parts.length ? parts.join(' · ') : '—';
}
